import { Component } from '@angular/core';
import { AuthService } from '../../../features/auth/services/auth/auth.service';

import { RouterLink, RouterOutlet } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@Component({
  selector: 'app-admin-layout',
  imports: [ RouterLink, NzIconModule, NzLayoutModule, NzMenuModule, RouterOutlet],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {
  isCollapsed = false;

  constructor(
    private authService: AuthService,
    
  ) { }

  logOut(): void {
    this.authService.logout();
    
  }

}
 

